module.exports = __webpack_public_path__ + "static/media/icon-boma.82b2f230.svg";